import { Card, CardHeader, Typography, Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { IoIosAddCircleOutline } from "react-icons/io";
import { useSelector } from "react-redux";
import { setDialog } from "../../../../app/slices/xraySlice";
import { FaXRay } from "react-icons/fa";
import XrayForm from "../../form";

const XrayHeader = () => {
  const dispatch = useDispatch();
  const _Xray = useSelector((state) => state.xray.xray.dialog);

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            الاشعة
          </Typography>
        }
        avatar={<FaXRay size={20} />}
        action={
          <Button
            variant="contained"
            color="primary"
            size="medium"
            startIcon={<IoIosAddCircleOutline />}
            onClick={() => dispatch(setDialog())}
          >
            إضافة
          </Button>
        }
      />
      {_Xray && <XrayForm />}
    </Card>
  );
};

export default XrayHeader;
